<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'tournamentList' }">{{$t('entities.tournament.plural')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing && model" :to="{ name: 'tournamentShow', params: { id: model.id } }">{{ model.name }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing">{{$t('table.edit')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!editing">{{$t('table.add')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title"> {{ editing ? $t('table.edit') + ' ' + $t('entities.tournament.singular') : $t('table.add') + ' ' + $t('entities.tournament.singular') }}</h2>

      <el-form
        ref="form"
        :model="model"
        :label-position="labelPosition"
        :label-width="labelWidth"
        :rules="rules"
        @submit.native.prevent="save"
      >
        <div class="block">
        <el-form-item label="Name" prop="name">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.name"
            ref="focus"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="Locality" prop="locality">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.locality"
            />
          </el-col>
        </el-form-item>

        <!-- <el-form-item label="Players" prop="players">
          <el-col :lg="11" :md="16" :sm="24">
            <el-select
              multiple
              filterable
              v-loading="options.players == null"
              v-model="model.players"
              value-key="id"
            >
              <template v-if="options.players">
                <el-option
                  v-for="option in options.players"
                  :key="option.id"
                  :label="option.label"
                  :value="option"
                />
              </template>
            </el-select>
          </el-col>
        </el-form-item> -->

        <el-form-item label="Country" prop="country">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.country"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="Web" prop="web">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.web"
            />
          </el-col>
        </el-form-item>

        <!-- <el-form-item label="Pictures">
          <el-col :lg="11" :md="16" :sm="24">
            <app-image-upload
              :stored="model.pictures"
            :size="2000000"
              ref="pictures"
            />
          </el-col>
        </el-form-item> -->
        </div>

        <div class="button-group mt-3">
          <el-button
            @click="save()"
            :disabled="loading"
            type="primary"
            icon="el-icon-fa-floppy-o"
          >
            Save
          </el-button>
          <el-button
            @click="back()"
            :disabled="loading"
            icon="el-icon-fa-times"
          >
            Cancel
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validators from '@/shared/form/validators';
/* eslint-disable */
export default {
  name: 'app-tournament-form',

  props: {
    id: String,
    previous: String,
  },

  data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        }),
        locality: validators.string({
          label: 'Locality',
          required: false
        }),
        players: validators.hasMany({
          label: 'Players',
          required: false
        }),
        country: validators.string({
          label: 'Country',
          required: false
        }),
        web: validators.string({
          label: 'Web',
          required: false
        }),
      },
    };
  },

  created() {
    this.$store.dispatch('entities/tournament/loadOptions');

    if (this.id) {
      this.$store
        .dispatch('entities/tournament/edit', this.id)
        .catch(() =>
          this.$router.push({ name: 'tournamentList' }),
        );
    } else {

      this.$store.dispatch('entities/tournament/new');
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/tournament/clear');
    this.$store.dispatch('entities/club/clear');
    next();
  },

  computed: {
    ...mapGetters({
      club: 'entities/club/model',
      model: 'entities/tournament/model',
      loading: 'entities/tournament/loading',
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth",
      options: 'entities/tournament/options',
    }),

    editing: state => !!state.id,
  },

  methods: {
    save() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store.dispatch('entities/tournament/save', this.model)
        .then(() => {
            this.back();
        });
      });
    },

    back() {
      this.$router.go(-1) 
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/tournament/tournament-form.vue?5a33801c